export const highlightPromptVariables = (prompt, delimiterStart = '{{', delimiterEnd = '}}') => {
  if (!prompt) return '';

  const escapeHTML = (str) =>
    str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const start = escapeRegex(delimiterStart);
  const end = escapeRegex(delimiterEnd);
  const regex = new RegExp(`${start}(.*?)${end}`, 'g');

  let escapedPrompt = escapeHTML(prompt);

  escapedPrompt = escapedPrompt.replace(/\r?\n/g, '<br>');

  const highlighted = escapedPrompt.replace(regex, (match, varName) => {
    return `<span contenteditable="false" class="variable-wrapper">
            <span class="bracket">[</span>
            <span contenteditable="true" class="variable">${escapeHTML(varName)}</span>
            <span class="bracket">]</span>
        </span>`;
  });

  return highlighted;
};
